module.exports = __webpack_public_path__ + "static/media/android.ce2594d7.png";